(function () {
  'use strict';

  var EXAMPLE_SERIAL = 'SSXD161993VEXLB047307';

  var MODEL_CODES = [
    { code: 'SZCZ', series: 'RZC' },
    { code: 'SZPR', series: 'RZ-PRO' },
    { code: 'SZHD', series: 'RZ-HD' },
    { code: 'SRPR', series: 'RT-PRO' },
    { code: 'SRHD', series: 'RT-HD' },
    { code: 'SSHD', series: 'SRT-HD' },
    { code: 'SSXD', series: 'SRT-XD' },
    { code: 'STPR', series: 'KG-PRO' },
    { code: 'STXD', series: 'KG-XD' },
    { code: 'SZH', series: 'RZ' },
    { code: 'SSP', series: 'SRT-PRO' }
  ];

  var YEAR_CODES = {
    E: '2014',
    F: '2015',
    G: '2016',
    H: '2017',
    J: '2018',
    K: '2019',
    L: '2020',
    M: '2021',
    N: '2022',
    P: '2023',
    Q: '2024',
    R: '2025',
    S: '2026',
    T: '2027'
  };

  var ENGINE_CODES = {
    VE: 'Vanguard EFI',
    VG: 'Vanguard',
    VA: 'Vanguard',
    VB: 'Vanguard Big Block',
    BS: 'Briggs and Stratton',
    BR: 'Briggs and Stratton',
    KA: 'Kawasaki',
    KF: 'Kawasaki FT/FX family',
    FR: 'Kawasaki FR family',
    KO: 'Kohler',
    KH: 'Kohler'
  };

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function normalizeSerial(value) {
    return String(value || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
  }

  function findModel(serial) {
    for (var i = 0; i < MODEL_CODES.length; i += 1) {
      if (serial.indexOf(MODEL_CODES[i].code) === 0) {
        return MODEL_CODES[i];
      }
    }
    return null;
  }

  function isDigits(value) {
    return /^[0-9]+$/.test(value);
  }

  function decodeSerial(rawValue) {
    var serial = normalizeSerial(rawValue);
    var warnings = [];
    var model = findModel(serial);
    var modelCode = model ? model.code : serial.slice(0, 4);
    var modelSeries = model ? model.series : 'Unknown model code';
    var rest = model ? serial.slice(model.code.length) : serial.slice(4);

    var modelDigit = rest.charAt(0);
    var deckSize = rest.slice(1, 3);
    var engineCc = rest.slice(3, 6);
    var engineCode = rest.slice(6, 8);
    var variantCode = rest.charAt(8);
    var yearLetter = rest.charAt(9);
    var plantCode = rest.charAt(10);
    var unitNumber = rest.slice(11);
    var year = YEAR_CODES[yearLetter] || 'Unknown year';
    var engineLabel = ENGINE_CODES[engineCode] || 'Code not in this guide';

    if (!serial) {
      warnings.push('Enter a Spartan serial number to decode.');
    }

    if (!model) {
      warnings.push('The model code was not found in the known Spartan code table. Recheck the first letters on the serial plate.');
    }

    if (serial && serial.length < 15) {
      warnings.push('This serial looks shorter than expected, so some fields may be incomplete.');
    }

    if (deckSize && !isDigits(deckSize)) {
      warnings.push('The deck size field is not numeric. Recheck the characters after the model/series digit.');
    }

    if (engineCc && !isDigits(engineCc)) {
      warnings.push('The engine displacement field is not numeric. Recheck the three digits after the deck size.');
    }

    if (yearLetter && !YEAR_CODES[yearLetter]) {
      warnings.push('The model year letter is not in the supported year-code table on this page.');
    }

    if (engineCode && !ENGINE_CODES[engineCode]) {
      warnings.push('The engine manufacturer code is not in this guide. Use the engine tag for the exact engine model and spec.');
    }

    return {
      serial: serial,
      modelCode: modelCode || 'Not found',
      modelSeries: modelSeries,
      modelDigit: modelDigit || 'Not found',
      deckSize: deckSize || 'Not found',
      engineCc: engineCc || 'Not found',
      engineCode: engineCode || 'Not found',
      engineLabel: engineLabel,
      variantCode: variantCode || 'Not found',
      yearLetter: yearLetter || 'Not found',
      year: year,
      plantCode: plantCode || 'Not found',
      unitNumber: unitNumber || 'Not found',
      warnings: warnings
    };
  }

  function resultItem(label, value, helper) {
    var helperHtml = helper ? '<em>' + escapeHtml(helper) + '</em>' : '';
    return '<div class="amp-ssg-result-item"><span>' + escapeHtml(label) + '</span><strong>' + escapeHtml(value) + '</strong>' + helperHtml + '</div>';
  }

  function formatDeck(decoded) {
    return decoded.deckSize !== 'Not found' && isDigits(decoded.deckSize) ? decoded.deckSize + ' inch' : decoded.deckSize;
  }

  function formatEngine(decoded) {
    return decoded.engineCc !== 'Not found' && isDigits(decoded.engineCc) ? decoded.engineCc + 'cc' : decoded.engineCc;
  }

  function breakdownItem(code, label) {
    return '<div><span>' + escapeHtml(code) + '</span><strong>' + escapeHtml(label) + '</strong></div>';
  }

  function renderResult(container, decoded) {
    var deckValue = formatDeck(decoded);
    var engineValue = formatEngine(decoded);
    var engineCodeValue = decoded.engineCode + (decoded.engineLabel ? ' - ' + decoded.engineLabel : '');
    var html = '';

    html += '<h3>Decoded serial: ' + escapeHtml(decoded.serial || 'Not entered') + '</h3>';
    html += '<div class="amp-ssg-result-grid">';
    html += resultItem('Model code', decoded.modelCode, 'First letters of the serial number');
    html += resultItem('Model series', decoded.modelSeries, 'Spartan mower family');
    html += resultItem('Model/series digit', decoded.modelDigit, 'Single digit after the model code');
    html += resultItem('Deck size', deckValue, 'Two digits after the model/series digit');
    html += resultItem('Engine CC', engineValue, 'Three-digit displacement field');
    html += resultItem('Engine manufacturer code', engineCodeValue, 'Use the engine tag for exact model and spec');
    html += resultItem('Variant/special code', decoded.variantCode, 'Build or variant position');
    html += resultItem('Model year letter', decoded.yearLetter, 'Letter from the year-code table');
    html += resultItem('Model year', decoded.year, 'Decoded from the year letter');
    html += resultItem('Production/plant code', decoded.plantCode, 'Production code position');
    html += resultItem('Unit number', decoded.unitNumber, 'Final unit sequence');
    html += resultItem('Parts lookup tip', 'Verify engine tag', 'Engine model/spec are not in the Spartan serial');
    html += '</div>';

    if (decoded.warnings.length) {
      html += '<div class="amp-ssg-alert"><strong>Check this:</strong> ' + escapeHtml(decoded.warnings.join(' ')) + '</div>';
    } else {
      html += '<div class="amp-ssg-alert"><strong>Good decode:</strong> Use the mower series, deck size, year, and unit number with the engine tag when ordering parts.</div>';
    }

    container.innerHTML = html;
  }

  function renderBreakdown(container, decoded) {
    if (!container) {
      return;
    }

    var deckValue = formatDeck(decoded);
    var engineValue = formatEngine(decoded);
    var vehicleTitle = decoded.modelSeries;
    var vehicleMeta = decoded.year + ' model year, ' + decoded.engineLabel + ', unit ' + decoded.unitNumber;
    var html = '';

    if (deckValue !== 'Not found') {
      vehicleTitle += ' with ' + deckValue + ' deck';
    }

    html += '<div class="amp-ssg-breakdown-vehicle">';
    html += '<span>Decoded vehicle</span>';
    html += '<strong>' + escapeHtml(vehicleTitle) + '</strong>';
    html += '<em>' + escapeHtml(vehicleMeta) + '</em>';
    html += '</div>';
    html += '<code class="amp-ssg-breakdown-serial">' + escapeHtml(decoded.serial || 'Enter a serial number') + '</code>';
    html += '<div class="amp-ssg-breakdown-grid">';
    html += breakdownItem(decoded.modelCode, decoded.modelSeries + ' model code');
    html += breakdownItem(decoded.modelDigit, 'Model/series digit');
    html += breakdownItem(decoded.deckSize, deckValue + ' deck');
    html += breakdownItem(decoded.engineCc, engineValue + ' engine');
    html += breakdownItem(decoded.engineCode, decoded.engineLabel + ' code');
    html += breakdownItem(decoded.variantCode, 'Variant/special code');
    html += breakdownItem(decoded.yearLetter, decoded.year + ' model year');
    html += breakdownItem(decoded.plantCode, 'Production/plant code');
    html += breakdownItem(decoded.unitNumber, 'Unit number');
    html += '</div>';

    if (decoded.warnings.length) {
      html += '<div class="amp-ssg-alert"><strong>Check this:</strong> ' + escapeHtml(decoded.warnings.join(' ')) + '</div>';
    }

    container.innerHTML = html;
  }

  function findGuideFromElement(element) {
    if (element && element.closest) {
      return element.closest('[data-amp-ssg-guide]');
    }

    return document.querySelector('[data-amp-ssg-guide]');
  }

  function updateUrl(serial) {
    if (!window.history || !window.URLSearchParams || !serial) {
      return;
    }

    var params = new URLSearchParams(window.location.search);
    params.set('serial', serial);
    var nextUrl = window.location.pathname + '?' + params.toString() + window.location.hash;
    window.history.replaceState(null, '', nextUrl);
  }

  function decodeGuide(guide, updateAddress, normalizeInput) {
    if (!guide) {
      return null;
    }

    var input = guide.querySelector('[data-amp-ssg-input]');
    var result = guide.querySelector('[data-amp-ssg-result]');
    var breakdown = guide.querySelector('[data-amp-ssg-breakdown]');

    if (!input || !result) {
      return null;
    }

    var decoded = decodeSerial(input.value);

    if (normalizeInput !== false) {
      input.value = decoded.serial;
    }

    renderResult(result, decoded);
    renderBreakdown(breakdown, decoded);

    if (updateAddress !== false) {
      updateUrl(decoded.serial);
    }

    return decoded;
  }

  window.ampSsgDecode = function (element) {
    decodeGuide(findGuideFromElement(element));
    return false;
  };

  window.ampSsgType = function (element) {
    if (element) {
      element.value = element.value.toUpperCase();
    }

    decodeGuide(findGuideFromElement(element), false, false);
    return false;
  };

  window.ampSsgExample = function (element) {
    var guide = findGuideFromElement(element);
    var input = guide ? guide.querySelector('[data-amp-ssg-input]') : null;

    if (input) {
      input.value = EXAMPLE_SERIAL;
      decodeGuide(guide);
      input.focus();
    }

    return false;
  };

  function initGuide(guide) {
    if (!guide || guide.getAttribute('data-amp-ssg-ready') === 'true') {
      return;
    }

    var form = guide.querySelector('[data-amp-ssg-form]');
    var input = guide.querySelector('[data-amp-ssg-input]');
    var result = guide.querySelector('[data-amp-ssg-result]');
    var breakdown = guide.querySelector('[data-amp-ssg-breakdown]');
    var decodeButton = guide.querySelector('[data-amp-ssg-decode]');
    var exampleButton = guide.querySelector('[data-amp-ssg-example]');

    if (!form || !input || !result) {
      return;
    }

    guide.setAttribute('data-amp-ssg-ready', 'true');

    function getSerialFromUrl() {
      if (!window.URLSearchParams) {
        return '';
      }

      var params = new URLSearchParams(window.location.search);
      return params.get('serial') || '';
    }

    function decodeCurrent(updateAddress, normalizeInput) {
      decodeGuide(guide, updateAddress, normalizeInput);
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      decodeCurrent();
    });

    if (decodeButton) {
      decodeButton.addEventListener('click', function () {
        decodeCurrent();
      });
    }

    input.addEventListener('input', function () {
      input.value = input.value.toUpperCase();
      decodeCurrent(false, false);
    });

    if (exampleButton) {
      exampleButton.addEventListener('click', function () {
        input.value = EXAMPLE_SERIAL;
        decodeCurrent();
        input.focus();
      });
    }

    var urlSerial = getSerialFromUrl();
    if (urlSerial) {
      input.value = urlSerial;
    }

    decodeCurrent(false);
  }

  function initAll(context) {
    var root = context || document;
    var guides = root.querySelectorAll('[data-amp-ssg-guide]');
    for (var i = 0; i < guides.length; i += 1) {
      initGuide(guides[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
}());
